import 'antd/es/slider/style';
import '@dfl/dashboard/dist/index.css';

import { CMSProviderClient } from '@dfl/react-cms-client';
import React, { memo, useEffect } from 'react';

import {ProposalCreationProvider} from '@/modules/proposalRequest/contexts/ProposalRequestCreation';

import MainRouter from './MainRouter';

const MainApp = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <CMSProviderClient>
      <ProposalCreationProvider>
        <MainRouter/>
      </ProposalCreationProvider>
    </CMSProviderClient>
  );
};

export default memo(MainApp);
